import { Users, Headset, Archive, CurrencyInr, Receipt, ChartLineUp, Wallet, Buildings, CheckSquare, Square } from '@phosphor-icons/react';

export const MODULES = [
  { key: 'tracker', label: 'Tracker', desc: 'Candidate tracker & monthly view', icon: Users, color: '#93C5FD' },
  { key: 'daily', label: 'Daily Follow-up', desc: 'Today\'s telecalling board', icon: Headset, color: '#A3E635' },
  { key: 'archive', label: 'Daily Archive', desc: 'Past days, read-only', icon: Archive, color: '#F9A8D4' },
  { key: 'finance', label: 'Finance', desc: 'Charges, balances & collections (shows ₹ everywhere)', icon: CurrencyInr, color: '#FDE047' },
  { key: 'billing', label: 'Billing', desc: 'Company invoices & PDFs', icon: Receipt, color: '#FDBA74' },
  { key: 'reports', label: 'Reports', desc: 'Month-wise recruiter reports', icon: ChartLineUp, color: '#C4B5FD' },
  { key: 'salary', label: 'Salary', desc: 'Staff payroll & pay slips', icon: Wallet, color: '#67E8F9' },
  { key: 'companies', label: 'Companies', desc: 'Directory + SLA agreements', icon: Buildings, color: '#86EFAC' },
];

export const DEFAULT_MODULES = ['tracker', 'daily', 'archive'];

export const ModulePicker = ({ value, onChange, testIdPrefix }) => {
  const set = new Set(value || []);
  const toggle = (k) => { const n = new Set(set); n.has(k) ? n.delete(k) : n.add(k); onChange([...n]); };
  const all = MODULES.every((m) => set.has(m.key));
  return (
    <div className="bg-[#F5F5F5] border-2 border-black rounded-md p-3" data-testid={`${testIdPrefix}-module-picker`}>
      <div className="flex items-center justify-between mb-2">
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-[#0A0A0A]">Tabs this user can open</div>
          <div className="text-[11px] text-[#555]">Dashboard is always available. Tick only what this person needs.</div>
        </div>
        <div className="flex gap-1">
          <button type="button" data-testid={`${testIdPrefix}-modules-all`} onClick={() => onChange(all ? [] : MODULES.map((m) => m.key))} className="text-[10px] font-bold px-2 py-1 bg-white text-black border-2 border-black rounded hover:bg-[#A3E635]">{all ? 'Clear all' : 'Select all'}</button>
          <button type="button" data-testid={`${testIdPrefix}-modules-default`} onClick={() => onChange([...DEFAULT_MODULES])} className="text-[10px] font-bold px-2 py-1 bg-white text-black border-2 border-black rounded hover:bg-[#FDE047]">Entry only</button>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
        {MODULES.map(({ key, label, desc, icon: Icon, color }) => {
          const on = set.has(key);
          return (
            <button
              type="button"
              key={key}
              data-testid={`${testIdPrefix}-module-${key}`}
              aria-pressed={on}
              onClick={() => toggle(key)}
              className={`flex items-start gap-2 text-left px-2.5 py-2 border-2 rounded-md transition-all ${on ? 'border-black shadow-[2px_2px_0px_0px_rgba(10,10,10,1)]' : 'border-[#ccc] bg-white opacity-70 hover:opacity-100'}`}
              style={on ? { backgroundColor: color } : undefined}
            >
              {on ? <CheckSquare size={18} weight="fill" className="text-black shrink-0 mt-0.5" /> : <Square size={18} className="text-[#777] shrink-0 mt-0.5" />}
              <Icon size={18} weight="duotone" className="text-black shrink-0 mt-0.5" />
              <div>
                <div className="text-xs font-black text-[#0A0A0A]">{label}</div>
                <div className="text-[10px] text-[#333] leading-tight">{desc}</div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
